import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateNoSalaryForm } from "../../../../absence-letter/components/create-no-salary-leave-form";
import { useAFLRequest } from "../../../../application-for-leave/hooks";

const dataFallback = {};

export const NoSalaryTSNEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin nghỉ không lương" loading={isRequestFetching}>
      <CreateNoSalaryForm data={data} />
    </ProcedureLayout>
  );
});
